export default __webpack_public_path__ + "00d5c1dc78719b38c9d494c99ab3198c.ttf";